var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('editor',{attrs:{"formula":false,"placeholder":_vm.field.properties.basic.hasPlaceholder ? _vm.field.properties.basic.placeholder : null,"disabled":"disabled"}})}
var staticRenderFns = []

export { render, staticRenderFns }